import { Box, IconButton,Tooltip, CircularProgress, Menu, MenuItem, Typography } from "@mui/material"
import React from "react"
import AnalyticsIcon from '@mui/icons-material/Analytics';
import { documentApi } from "../../../api-interface";
import { TenantContext } from "../../..";
import { JobResponse, JobStatus } from "../../../api";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import {  } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useRevalidator } from "react-router-dom";

const JobErrorIcon = ({message}:{message:string}) => {
    return <Tooltip title={message} sx={{cursor: 'pointer'}}><ErrorOutlineIcon color="error" /></Tooltip>
}



const JobItem = ({ job }: {job : JobResponse}) => {
    const icon = <Box sx={{display: 'flex', alignItems: 'center', gap: 1, padding: 1}}>
        { (job.status === JobStatus.InProgress || job.status === JobStatus.Pending) ? <CircularProgress size={20} /> : job.status === JobStatus.Completed ? <TaskAltIcon /> : <JobErrorIcon message={String(job.error_message)} />}
    </Box>
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            padding: 1,
            borderTop: '1px solid #ccc', 
        }}>
        {icon}
            {job.original_filename}
        </Box>
    )
}


const Jobs = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [jobs, setJobs] = React.useState<JobResponse[]|null>(null);
    const tenant_id = React.useContext(TenantContext)
    const revalidator = useRevalidator();

    // Function to compare the current jobs with the fetched jobs
    const compareJobs = (currentJobs: JobResponse[], newJobs: JobResponse[]) => {
        if (currentJobs.length !== newJobs.length) {
            return false; // Different lengths, so they are not equal
        }
        // Compare each job in the arrays
        for (let i = 0; i < currentJobs.length; i++) {
            const currentJob = currentJobs[i];
            const newJob = newJobs[i];
            // Compare job properties
            if (currentJob.id !== newJob.id ||
                currentJob.status !== newJob.status ||
                currentJob.original_filename !== newJob.original_filename ||
                currentJob.error_message !== newJob.error_message) {
                return false; // Found a difference, so they are not equal
            }
        }
        return true; // All jobs are equal
    };
    
    React.useEffect(() => {
        const fetchJobs = async () => {
            try {
                const newJobs = await documentApi(tenant_id).getJobsDocumentJobsGet();
                setJobs((prevJobs) => {
                    if (prevJobs && !compareJobs(prevJobs || [], newJobs.data)) {
                        console.log("Jobs updated", newJobs.data);
                        revalidator.revalidate();
                    }
                    return newJobs.data;
                });
            } catch (error) {
                console.error("Error fetching jobs:", error);
            }
        };
        fetchJobs();
        const interval = setInterval(fetchJobs, 1000);
        return () => clearInterval(interval);
    }, []);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const isLoading = jobs !== null && jobs.length > 0 && jobs.some(job => job.status === JobStatus.InProgress);
    return(
        <Box>
        <IconButton color='inherit' sx={{
          position: 'relative',
          color: 'white',
          top: -10,
          left: 24,
          zIndex: 1,
        }}
        onClick={handleClick}><AnalyticsIcon /></IconButton>
        <CircularProgress
          size={40}
          sx={{
            color: 'white',
            position: 'relative',
            top: 5,
            left: -15,
            zIndex: -1,
            visibility: isLoading ? 'visible' : 'hidden',
          }}
        />
        <Typography>
          <Menu
            id="jobs-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <Typography variant="h6" sx={{ flexGrow: 1, textAlign: 'center', padding: 1 }}>
                Jobs
            </Typography>
            {jobs !== null ? (
                jobs.map((job, index) => <JobItem key={index} job={job} />)
            ) : (
                <MenuItem disabled>Loading jobs...</MenuItem>
            )}
          </Menu>
        </Typography>
      </Box>
    )
}

export default Jobs